import { Modal, Row, Col, Button } from 'antd';
import React from 'react';

const wrapStyle = { whiteSpace: 'normal', wordWrap: 'break-word', wordBreak: 'break-all', marginBottom: 8, textAlign: 'center' };
const colContentCenterStyle = { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' };

export default function Index() {
  const [open, setOpen] = React.useState(false);
  const list = [
    { label: '原料供应商', describe: '请通过业务员的邀请链接进入申请页', href: undefined, imageSrc: 'https://cp-cpmart-dev.oss-cn-beijing.aliyuncs.com/38c3110daa2f9256cf7eb2dacbdc0510.jpg' },
    { label: '物流承运商', describe: '申请入驻', href: `/supplier/apply?invite_logistics=1`, imageSrc: 'https://cp-cpmart-dev.oss-cn-beijing.aliyuncs.com/18c204cc706fdbaec41ae0fb4cf42f9f.jpg' },
    { label: '其他供应商', describe: '申请入驻', href: '/supplier/apply?invite_logistics=0', imageSrc: 'https://cp-cpmart-dev.oss-cn-beijing.aliyuncs.com/a1a35f7a7cb39874634d1adcaa8e4ccb.jpg' }
  ];

  const SupplierApplyModal = (
    <Modal title='申请成为供应商' open={open} onCancel={() => setOpen(false)} footer={null} getContainer={false} destroyOnHidden>
      <Row gutter={16} justify="center">
        {list.map((item, index) => <Col span={8} key={index}>
          <div style={colContentCenterStyle}>
            <img src={item.imageSrc} style={{ maxWidth: '100%', height: '100px' }} alt={item.label} />
            <div style={wrapStyle}>{item.label}</div>
            <Button size="small" type={item.href ? 'primary' : 'link'} href={item.href} style={{ ...wrapStyle, fontSize: 12 }} block>{item.describe}</Button>
          </div>
        </Col>)}
      </Row>
    </Modal>
  );

  return {
    open: () => setOpen(true),
    close: () => setOpen(false),
    SupplierApplyModal
  };
}
